import { Component, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from "@angular/router";
import { ProfileService } from '../../../services/profile.service';
import { AuthenticationService } from '../../../services/authentication.service';
import { CommonService } from '../../../services/common.service';
import { DomSanitizer, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-connection-list',
  templateUrl: './connection-list.component.html',
  styleUrls: ['./connection-list.component.scss']
})
export class ConnectionListComponent implements OnInit {


    pageSize: any = 5;

    loadingMessage: string = "Loading...";

    @Input() connectionList: any[] = [];
    @Input() title: string = "connection";
    @Input() showLoading: boolean = false;

    constructor(private authentication: AuthenticationService, private _router: Router, private _commonService: CommonService) {

    }


    ngOnInit(): void {

    }
    openConnection() {
        this._router.navigate(['/profile/connections']);

    }
    more() {
        this.pageSize = this.pageSize + 5;
    }
    openUserProfile(profileUserId: any) {
        this._router.navigate(['/profile/user-profile/' + profileUserId]);
    }

}
